import { Badge, Button, Layout } from 'antd';
import { NotificationOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { ReactNode, useState } from 'react';
import BuildingGate from '../../components/BuildingGate';
import FullscreenButton, {
	TABLET_FLOATING_ACTION_PX,
} from '../../components/Operations/FullscreenButton';
import { UserGuideModal, TABLET_SECTIONS } from '../../features/user-guide';
import { UpdatesModal, useUnseenUpdates } from '../../features/updates';

type Props = { children: ReactNode };
export default function TabletLayout({ children }: Props) {
	const [userGuideOpen, setUserGuideOpen] = useState(false);
	const [updatesOpen, setUpdatesOpen] = useState(false);

	const {
		items: roadmapItems,
		isLoading: roadmapLoading,
		unseenCount,
		markSeen,
		refresh: refreshUpdates,
	} = useUnseenUpdates();

	function openUpdates() {
		refreshUpdates(); // tablets sit open for days; refetch before showing
		setUpdatesOpen(true);
		markSeen();
	}

	function closeUpdates() {
		markSeen(); // cover items that arrived while the window was up
		setUpdatesOpen(false);
	}
	return (
		<Layout style={{ height: '100%', minHeight: '100vh' }}>
			<div className="flex justify-around h-full">
				<BuildingGate>{children}</BuildingGate>
			</div>
			<div
				role="group"
				aria-label="Tablet tools"
				style={{
					position: 'fixed',
					right: 16,
					bottom: 16,
					zIndex: 1000,
					display: 'flex',
					flexDirection: 'column-reverse',
					alignItems: 'center',
					gap: 12,
				}}
			>
				<Badge dot={unseenCount > 0} offset={[-6, 6]}>
					<Button
						type="primary"
						shape="circle"
						icon={<NotificationOutlined style={{ fontSize: 22 }} />}
						onClick={openUpdates}
						aria-label="Open what's new and what's coming"
						style={{
							width: TABLET_FLOATING_ACTION_PX,
							height: TABLET_FLOATING_ACTION_PX,
							minWidth: TABLET_FLOATING_ACTION_PX,
							paddingInline: 0,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					/>
				</Badge>
				<Button
					type="primary"
					shape="circle"
					icon={
						<QuestionCircleOutlined style={{ fontSize: 22 }} />
					}
					onClick={() => setUserGuideOpen(true)}
					aria-label="Open user guide"
					style={{
						width: TABLET_FLOATING_ACTION_PX,
						height: TABLET_FLOATING_ACTION_PX,
						minWidth: TABLET_FLOATING_ACTION_PX,
						paddingInline: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				/>
				<FullscreenButton />
			</div>
			<UserGuideModal
				open={userGuideOpen}
				onClose={() => setUserGuideOpen(false)}
				sections={TABLET_SECTIONS}
				portal="tablet"
				manualTitle="Fastlane Tablet — User Guide"
			/>
			<UpdatesModal
				open={updatesOpen}
				onClose={closeUpdates}
				items={roadmapItems}
				isLoading={roadmapLoading}
				touch
			/>
		</Layout>
	);
}
